import { lazy } from "react";

export const LandingFifthScreenAsync = lazy(() => import("./LandingFifthScreen"));
